import {paths} from "@/lib/paths";

/** Login page shell once session + site status are known. */
export type LoginAuthShellMode = "pending" | "minimal" | "embedded";

export function getLoginAuthShellMode(
  pathname: string,
  user: {authenticated?: boolean} | null | undefined,
  sessionReady: boolean,
  siteReady: boolean,
  publicAccess: boolean
): LoginAuthShellMode | null {
  if(pathname !== paths.login) return null;
  if(user?.authenticated) return "embedded";
  if(!sessionReady || !siteReady) return "pending";
  return publicAccess ? "embedded" : "minimal";
}

/** Whether the storefront header/footer should render for the current guest/auth state. */
export function shouldShowShopChrome(
  pathname: string,
  user: {authenticated?: boolean} | null | undefined,
  sessionReady: boolean,
  siteReady: boolean,
  publicAccess: boolean
): boolean {
  if(pathname.startsWith("/vadmin")) return false;
  if(user?.authenticated) return true;

  const loginMode = getLoginAuthShellMode(pathname, user, sessionReady, siteReady, publicAccess);
  if(loginMode !== null) return loginMode === "embedded";

  if(pathname === paths.presentation) return false;

  // Guest on catalog pages: wait until we know access mode — avoids header flash on private shops.
  if(!sessionReady || !siteReady) return false;
  return publicAccess;
}
